export const LANDING = '/';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/login';
export const HOME = '/home';
export const APP = '/app';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const confirmation = '/confirmation';
export const PASSWORD_FORGET = '/pw-forget';
export const ADMIN_DETAILS = '/admin/:id';